<template>
  <div id="component-chat-log" class="m-8" >

    <template v-if="data.length === 0">
                <vs-divider class="msg-time">
                    <span>  {{ $t('no_comments') }} </span>
                </vs-divider>
            </template>

    <div v-for="(item, index) in data" class="msg-grp-container" :key="index">
      <div class="spacer mt-8" v-if="index !== 0"></div>
      <div
        class="flex items-start"
        :class="[ isEven(index) ? 'flex-row-reverse' : '']"
      >
           <vs-avatar color="#7367F0"  width="40" height="40" class="rounded-full shadow-md cursor-pointer block " :class="isEven(index) ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"/>
        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg w-full"
          :class="[ isEven(index) ? 'border border-solid border-transparent bg-white' : 'bg-primary-gradient text-white']"
        >
          <span>{{ item.comment }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default:() => [],
      required: true
    }
  },
  methods: {
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to))
      const date_time_from = new Date(Date.parse(time_from))
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      )
    },
    toDate(time) {
      const locale = 'en-us'
      const date_obj = new Date(Date.parse(time))
      const monthName = date_obj.toLocaleString(locale, {
        month: 'short'
      })
      return `${date_obj.getDate()} ${monthName}`
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
      })
    },
    isEven(index){
       let result = index % 2 ? true : false
       return result
    }
  },
  
  updated() {
    this.scrollToBottom()
  },
  mounted() {
    this.scrollToBottom()
  }
}
</script>
